export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/sleep-tangerine.755ecdb6db700f77bb8084d276871abe.png";